import React from "react";

function CastCard({ c, index, t }) {
  const has = !!c.photo;
  return (
    <article
      data-testid={`cast-card-${index}`}
      className="group relative overflow-hidden border border-[#F1EDE6]/10 bg-[#111113] aspect-[4/5] reveal"
      style={{ animationDelay: `${index * 70}ms` }}
    >
      {has ? (
        <>
          <img
            src={c.photo}
            alt={c.name}
            className="absolute inset-0 w-full h-full object-cover grayscale-[0.35] contrast-[1.05] transition-all duration-700 group-hover:grayscale-0 group-hover:scale-[1.04]"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0B0B0C] via-[#0B0B0C]/20 to-transparent" />
        </>
      ) : (
        <div data-testid={`cast-locked-${index}`} className="absolute inset-0 ep-locked-stripes scanlines flex flex-col items-center justify-center text-center">
          <div className="condensed text-[88px] md:text-[110px] text-[#F1EDE6]/15 leading-none">?</div>
          <div className="mt-2 condensed text-[26px] text-[#F1EDE6]/70 flicker">{t.cast_soon_label}</div>
          <div className="mt-1 mono text-[8px] uppercase tracking-[0.26em] text-[#F1EDE6]/40 px-4">{t.cast_soon_hint}</div>
        </div>
      )}
      <div className="absolute top-3 left-3 mono text-[9px] tracking-[0.26em] text-[#F1EDE6]/70 bg-[#0B0B0C]/60 backdrop-blur px-2 py-1">
        {String(index + 1).padStart(2, "0")}
      </div>
      {has && (
        <div className="absolute bottom-0 left-0 right-0 p-5">
          <div className="condensed text-[36px] md:text-[42px] text-[#F1EDE6] leading-none">{c.name}</div>
          <div className="mt-1 mono text-[9px] uppercase tracking-[0.24em] text-[#F1EDE6]/60">
            {c.handle ? (
              <a href={`https://instagram.com/${String(c.handle).replace(/^@/, "")}`} target="_blank" rel="noreferrer" className="hover:text-[color:var(--alta-red-soft)] transition-colors">
                {c.handle.startsWith("@") ? c.handle : `@${c.handle}`}
              </a>
            ) : (
              c.tag
            )}
          </div>
        </div>
      )}
    </article>
  );
}

export default function CastGrid({ t }) {
  const cast = Array.isArray(t.cast) ? t.cast : [];
  return (
    <section id="elenco" data-testid="reality-cast" className="relative bg-[#0B0B0C] py-24 md:py-32 border-t border-[#F1EDE6]/10">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-10 items-end">
          <div className="md:col-span-7">
            <div className="mono text-[10px] uppercase tracking-[0.32em] text-[color:var(--alta-red-soft)]">{t.cast_eyebrow}</div>
            <h2 className="mt-5 condensed text-[56px] md:text-[96px] text-[#F1EDE6] whitespace-pre-line">{t.cast_title}</h2>
          </div>
          <p className="md:col-span-5 text-[15px] md:text-[17px] leading-[1.75] text-[#F1EDE6]/65 font-light max-w-[46ch]">{t.cast_body}</p>
        </div>
        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {cast.map((c, i) => <CastCard key={c.id || i} c={c} index={i} t={t} />)}
        </div>
      </div>
    </section>
  );
}
